import { playerStore } from "../../../../store/player.store"
import { AudioVisualizer } from "../../../../components/elements/audio-visual"
import { StartBirdsWrap } from "../start-birds-wrap"
import { observer } from "mobx-react"

const StartEffects = observer(() => {

  return (
    <>
      {
        playerStore.isPlayerClick && (
          <>
            <AudioVisualizer />
            <StartBirdsWrap />
          </>
        )
      }
    </>
  )
})

export {
  StartEffects
}